import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';

import { ContactLensCartCard } from './components';
import { MOCK_DATA_CONTACT_LENS_CART_LIST } from './mockupConstants';
import './BaseContactLensCart.scss';

const ContactLensCart = () => {
  const [listOfProducts, setListOfProducts] = useState(MOCK_DATA_CONTACT_LENS_CART_LIST);
  const isPreProd = process.env.ENVIRONMENT === 'preprod';

  if (!isPreProd) {
    return <Redirect to="/" />;
  }

  return listOfProducts.length > 0 ? (
    <div className="base-contact-lens-cart">
      <div className="base-contact-lens-cart__container">
        <div>
          {listOfProducts.map(product => (
            <ContactLensCartCard
              key={product.id}
              product={product}
              onDeleteProduct={() => {
                setListOfProducts(listOfProducts.filter(({ id }) => id !== product.id));
              }}
            />
          ))}
        </div>

        <div className="base-contact-lens-cart__bill-container">
          <span>BILL SPACE</span>
        </div>
      </div>
    </div>
  ) : (
    <p className="base-contact-lens-cart__empty-cart-text">No products in cart</p>
  );
};

export default ContactLensCart;
